import React from 'react'
import { config } from '../../../../config'
import './Consent.css'


function Consent(props) {

    const [isSubmitting, setIsSubmitting] = React.useState(false);
    const [preferences, setPreferences] = React.useState({
        tos: false,
        privacyPolicy: false,
        rvpOver17: false
    });

    function propChange(e) {
        let _prop = { ...preferences };
        _prop[e.target.name] = e.target.type === 'checkbox' ? e.target.checked : e.target.value;;
        setPreferences({ ..._prop });
    }

    function next() {
        setIsSubmitting(true);

        if (props.wizardState?.leagueCategory === "Mixed" && props.wizardState?.productId === "379" &&
            preferences.tos === true && preferences.privacyPolicy === true && preferences.rvpOver17 === true) {
                props.nextView(props.wizardState);
        }

        if ((props.wizardState?.leagueCategory !== "Mixed" || props.wizardState?.productId !== "379") &&
            preferences.tos === true && preferences.privacyPolicy === true) {
            props.nextView(props.wizardState);
        }
    }

    return (
        <>
            <div className='custom-card' style={{ minHeight: '400px' }}>
                <div className="row">
                    <div className="col h4 wizard-step-title">
                        Terms of Service and Privacy Policy
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <div className="checkbox-wrapper-19">
                            <input type="checkbox" value="" id="tos" name='tos' onChange={propChange} />
                            <label className="check-box" htmlFor="tos" />
                            <label className='check-box-label' htmlFor="tos">
                                I have read, understand and agree to the <a href='#' onClick={() => window.open(config.termsOfServiceUrl, '_blank', 'height=600px,width=700px')} style={{ color: '#00338d' }}>Terms of Service</a>. The member agrees to be bound by and comply with the USBC Bylaws, Rules and Policy Manuals.
                            </label>
                        </div>
                        <div className="checkbox-wrapper-19 mt-3">
                            <input type="checkbox" value="" id="privacyPolicy" name='privacyPolicy' onChange={propChange} />
                            <label className="check-box" htmlFor="privacyPolicy" />
                            <label className='check-box-label' htmlFor="privacyPolicy">
                                I have read and understand that my, and if applicable, my child’s, personal information may be collected and used as described in the <a href='#' onClick={() => window.open(config.privacyPolicyUrl, '_blank', 'height=600px,width=700px')} style={{ color: '#00338d' }}>Privacy Policy</a>.
                            </label>
                        </div>
                        {(props.wizardState?.leagueCategory == "Mixed" && props.wizardState?.productId === "379")  && 
                            <div className="checkbox-wrapper-19 mt-3">
                                <input type="checkbox" value="" id="rvpOver17" name='rvpOver17' onChange={propChange} />
                                <label className="check-box" htmlFor="rvpOver17" />
                                <label className='check-box-label' htmlFor="rvpOver17">
                                All bowlers 18 and over must complete SafeSport training if any bowler is 17 or younger in the league.  They can access this training through their <a href='#' onClick={() => window.open("https://apps1.bowl.com/AthleteSafetyPortal", '_blank', 'height=600px,width=700px')} style={{ color: '#00338d' }}>Community Athlete Safety Portal</a>.  Instructions will be included in the League Registration order confirmation email.
                                </label>
                            </div>
                        }
                    </div>
                </div>

                {((preferences.tos === false || preferences.privacyPolicy === false)
                    && isSubmitting === true)  && 
                        <div className="alert alert-danger mt-2" role="alert">
                            Please confirm the Terms of Service and Privacy Policy.
                        </div>
                }
                {(props.wizardState?.leagueCategory === "Mixed" && props.wizardState?.productId === "379" &&
                    preferences.rvpOver17 === false
                    && isSubmitting === true)  && 
                        <div className="alert alert-danger mt-2" role="alert">
                            Please confirm the SafeSport training requirement.
                        </div>
                }

            </div>
            <div className='wizard-buttons-container'>
                <button type="button" className="btn btn-primary bowl-btn" onClick={props.backView}>Back</button>
                <button type="button" className="btn btn-primary bowl-btn" onClick={next}>Next</button>
            </div >
        </>
    )
};

export default Consent;

